import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

import firebase from "@/firebase/";
const firestore = firebase.firestore();
const websiteVariablesDoc = firestore
  .collection("websiteVariables")
  .doc("websiteVariables");
const auth = firebase.auth();
import { getExtraUserData } from "@/helper_functions";

Vue.config.productionTip = false;

let app;
auth.onAuthStateChanged(async user => {
  if (!app) {
    // Load website variables
    let websiteVariables = await websiteVariablesDoc.get();
    store.state.websiteVariables = websiteVariables.data();

    if (user) {
      // Load extra user information
      let extraInfo = await getExtraUserData(user.uid);

      // Add information to user object
      user = { ...user, ...extraInfo };

      // Save the user to vuex
      store.state.user = user;
    } else {
      store.state.user = null;
    }
    app = new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount("#app");
  }
});
